import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { foundAlliance, openDialog } from "../../../store/actions";
import { checkDuplicity } from "../../../lib/commonFunctions";
import { CONTENT_CONTEXT } from "../../../lib/enums";

interface IProps {
  elementRef: any;
}

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  foundAllianceDispatch: (allianceName: string) => dispatch(foundAlliance(allianceName))
});

const connector = connect(null, mapDispatchToProps);

const FoundAlliance = ({
  elementRef,
  openDialogDispatch,
  foundAllianceDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [allianceName, setAllianceName] = useState<string | null>(null);
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const nameInputRef = useRef<HTMLInputElement>(null);
  let inputCheckTimer: any;

  useEffect(() => {
    if (nameInputRef.current) {
      nameInputRef.current.addEventListener("blur", () => checkError);
    }

    return () => {
      if (nameInputRef.current) {
        nameInputRef.current.removeEventListener("blur", () => checkError);
      }
    }
  })

  const handleInputChange = (name: string) => {
    if (inputCheckTimer) {
      clearTimeout(inputCheckTimer);
    }
    setAllianceName(name);
    inputCheckTimer = setTimeout(() => checkError(name), 300);
  }

  const checkError = async (name?: string) => {
    const checkedName = name || allianceName;
    if (!checkedName) {
      setError(true);
      setErrorMessage("Alliance name can not be empty");
      return;
    }
    const duplicate = await checkDuplicity(checkedName, CONTENT_CONTEXT.Alliance);
    if (duplicate) {
      setError(true);
      setErrorMessage("Name already used for active alliance");
      return;
    }

    if (!(checkedName && checkedName.length > 2 && checkedName.length < 18)) {
      setError(true);
      setErrorMessage("Name has to have between 3 and 17 characters");
      return;
    }

    setError(false);
    setErrorMessage("");
  }

  const handleSubmit = async () => {
    await checkError();
    if (!error && allianceName) {
      foundAllianceDispatch(allianceName);
    }
  }

  return (
    <>
      <div className={"dialog-content"}>
        <table className="table">
          <tr>
            <td className={"no-border"}>Alliance name - choose name for the alliance between 3 - 17 characters</td>
          </tr>
          <tr>
            <td className={"no-border"}>
              <input
                id={"alliance-name"}
                ref={nameInputRef}
                type="text"
                className="input"
                value={allianceName || ""}
                onChange={e => handleInputChange(e.target.value)}
              />
              {error && <span className={"negative"}>{errorMessage}</span>}
            </td>
          </tr>
        </table>
      </div>
      <div className={"dialog-footer"}>
        <a
          onClick={() => openDialogDispatch({
            name: "AllianceActions",
            header: "Join the alliance",
            clear: true,
            elementRef
          })}
          className="btn btn-blank btn-no-width"
        >
          Back
        </a>
        <button
          onClick={handleSubmit}
          className={`btn btn-blank btn-no-width ${error ? "disabled" : ""}`}
        >
          Found
        </button>
      </div>
    </>
  )
}

export default connector(FoundAlliance);
